import React, { useRef, useState } from 'react';
import { Box, Button, Stack, Tab, Tabs } from '@curves/ui-base';

import SmartFitnessBandPromotionPlanTable from '@Local/PromotionPlan/SmartFitnessBandPromotionPlan/SmartFitnessBandPromotionPlanTable';
import SmartFitnessBandPromotionPlanSearchBar from '@Local/PromotionPlan/SmartFitnessBandPromotionPlan/SmartFitnessBandPromotionPlanSearchBar';
import { DeviceOrderPlanProvider, useDeviceOrderPlanContext } from '@Local/PromotionPlan/Components/DeviceOrderPlanContext';
import { SmartFitnessBandPromotionPlanDialogBox } from '@Local/PromotionPlan/SmartFitnessBandPromotionPlan/Dialog';
import { initBookmark } from '@Local/PromotionPlan/staticData';
import { PageLayout } from '@Local/Components/Layout';
import { PROMOTIONPLAN_TYPE } from '@Constants';
const SmartFitnessBandPromotionPlanTabs = () => {
    const planTypeMap = [
        {
            label: 'i私教優惠',
            value: PROMOTIONPLAN_TYPE.PRIVATECOACH,
        },
    ];
    const { planType, setPlanType, dialogRef, refresh } = useDeviceOrderPlanContext();
    const handleChangeTabs = (_, val) => {
        if (typeof setPlanType === 'function') setPlanType(val);
    };
    const handleOpenSmartFitnessBandPromotionPlanDialog = () => {
        if (dialogRef.current && dialogRef.current.openSmartFitnessBandPromotionPlanDialog) {
            dialogRef.current.openSmartFitnessBandPromotionPlanDialog(null, refresh);
        }
    };
    return (
        <Stack justifyContent={'space-between'} alignItems={'center'}>
            <Tabs value={planType} onChange={handleChangeTabs}>
                {planTypeMap.map((item) => (
                    <Tab key={item.value} className={'py-3'} label={item.label} value={item.value} />
                ))}
            </Tabs>
            <Box className="btn-group">
                <Button variant={'outlined'} onClick={handleOpenSmartFitnessBandPromotionPlanDialog} color="primary">
                    新增方案
                </Button>
            </Box>
        </Stack>
    );
};
const SmartFitnessBandPromotionPlanPage = (prop) => {
    const [sourceData, setSourceData] = useState({});
    const [planType, setPlanType] = useState(5);
    const [bookmark, setBookmark] = useState({
        ...initBookmark(),
    });
    const refreshRef = useRef(null);
    const dialogRef = useRef(null);
    const childContext = {
        dialogRef: dialogRef,
        sourceData,
        setSourceData,
        planType,
        setPlanType,
        bookmark,
        setBookmarkNum: (num) => setBookmark((pre) => ({ ...pre, pageIndex: num })),
        refresh: () => typeof refreshRef.current === 'function' && refreshRef.current(),
        setRefresh: (fn) => (refreshRef.current = fn),
    };
    return (
        <DeviceOrderPlanProvider value={childContext}>
            <PageLayout className={'promotion-plan-container'}>
                <PageLayout.Header title="智能行銷方案" />
                <SmartFitnessBandPromotionPlanSearchBar />
                <SmartFitnessBandPromotionPlanTabs />
                <SmartFitnessBandPromotionPlanTable />
                <SmartFitnessBandPromotionPlanDialogBox ref={dialogRef} />
            </PageLayout>
        </DeviceOrderPlanProvider>
    );
};
export default SmartFitnessBandPromotionPlanPage;